<template>
    <Notifications />
</template>

<script>
import Notifications from '../modules/notifications/index.vue';
export default {
    metaInfo: {
        title: 'Notifications',
    },
    components: {
        Notifications,
    },
};
</script>

<style lang="scss" scoped></style>
